<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>액션 시민 {{ props.isEdit ? "수정" : "추가" }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sign_form custom_scroll">
            <ul>
                <li class="imp">
                    <label for="group_title" class="form_li_tit">닉네임</label>
                    <input id="group_title" type="text" placeholder="닉네임을 입력하세요" v-model="form_state.nickname" />
                </li>
            </ul>
            <hr />
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">닫기</button>
                <button class="submit_btn _130 _blue" @click="callBackModal">저장</button>
            </div>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="state.isShowModal = false"
        @callback=""
    ></ModalDefault>
</template>

<script lang="ts">
    import { reactive, ModalDefault, types, PageBtn, CommonUtils, onMounted } from "@/BaseComponent";

    export default {
        props: {
            data: { type: Object, default: {} },
            isEdit: { type: Boolean },
        },
        emits: ["close", "callback"],
        components: { ModalDefault, PageBtn },
        setup(props: any, { emit }: any) {
            const state = reactive({
                isShowModal: false as boolean,
                mode: true as boolean,
                list: [] as types.ResMemberDetailVOForApi[],
                currentPage: 1 as number,
                perPage: 10 as number,
                totalLength: 0 as number,
            });

            const modal = reactive({
                title: "" as string,
                content: "" as string,
                tab: 0 as number,
            });

            const form_state = reactive({
                nickname: "" as string,
            });

            onMounted(() => {
                form_state.nickname = props.data.nickname;
            });

            const closeModal = () => emit("close");

            const callBackModal = async (param: any) => {
                if (!form_state.nickname) {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "닉네임을 입력해주세요";
                } else {
                    param = { nickname: form_state.nickname };
                    emit("callback", param);
                }
            };

            return { CommonUtils, props, state, modal, form_state, closeModal, callBackModal };
        },
    };
</script>

<style>
    .blocked,
    input:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
</style>
